import React, { useState } from 'react'
import { Upload, Col, Typography, Spin, notification, Row } from 'antd'
import styled from 'styled-components'
import { RcFile, UploadChangeParam } from 'antd/lib/upload'
import { useTranslation } from 'react-i18next'

import { useDownload } from '@hooks'

const StyledUploadButton = styled(Typography)`
  color: ${({ theme }) => theme.primaryColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
  cursor: pointer;
`
const UploadedFile = styled(Typography)`
  color: ${({ theme }) => theme.primaryColor};
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
`
const StyledCol = styled(Col)`
  margin: 10px 0 10px;
`

const StyledRow = styled(Row)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

interface Props {
  onChange: (file: File | null) => void
  fileData?: { key?: string; name: string }[]
}

const UploadSingleFile: React.FC<Props> = ({ onChange, fileData }) => {
  const [isImageUpload, setIsImageUpload] = useState(false)
  const { t } = useTranslation()
  const { downloadFile, isLoading } = useDownload()

  const uploadButton = <StyledUploadButton>{t('globals.add_file')}...</StyledUploadButton>

  const handleChange = ({ fileList }: UploadChangeParam) => {
    if (fileList.length) {
      setIsImageUpload(true)
      onChange(fileList[0].originFileObj as File)
    }
  }

  const handleRemove = () => {
    setIsImageUpload(false)
    onChange(null)
  }

  return (
    <Spin spinning={isLoading}>
      <Upload
        className="avatar-uploader"
        beforeUpload={(file: RcFile) => {
          if (file.type !== 'application/pdf') {
            notification.error({
              message: t('globals.pdf_format'),
            })
          }
          return file.type === 'application/pdf' ? false : Upload.LIST_IGNORE
        }}
        onChange={handleChange}
        onRemove={handleRemove}
      >
        {!isImageUpload && uploadButton}
      </Upload>
      <StyledRow>
        {fileData?.map(file => (
          <StyledCol
            key={file.key}
            onClick={() => {
              downloadFile({ key: file.key!, name: file.name })
            }}
          >
            <UploadedFile>{`${file.name}`}</UploadedFile>
          </StyledCol>
        ))}
      </StyledRow>
    </Spin>
  )
}
export { UploadSingleFile }
